import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.5}
      y={0.5}
      width={29}
      height={29}
      rx={5.5}
      fill={props.bgcolor}
      stroke="#947550" />
    <path
      d="M7.8005 24.0002C7.4725 24.0002 7.2005 23.7345 7.2005 23.4141V7.78624C7.2005 7.46587 7.4725 7.2002 7.8005 7.2002C8.1285 7.2002 8.4005 7.46587 8.4005 7.78624V23.4141C8.4005 23.7345 8.1285 24.0002 7.8005 24.0002Z"
      fill={props.color}
    />
    <path
      d="M16.631 19.1999H7.79237C7.46882 19.1999 7.2005 18.9279 7.2005 18.5999C7.2005 18.2719 7.46882 17.9999 7.79237 17.9999H16.631C17.4912 17.9999 17.8936 17.7679 17.9725 17.5679C18.0515 17.3679 17.9331 16.9199 17.3175 16.3039L16.3706 15.3439C15.9839 14.9999 15.7471 14.4799 15.7234 13.9039C15.6998 13.2959 15.9365 12.6959 16.3706 12.2559L17.3175 11.2959C17.9015 10.7039 18.083 10.2239 17.9962 10.0159C17.9094 9.8079 17.4596 9.5999 16.631 9.5999H7.79237C7.46092 9.5999 7.2005 9.3279 7.2005 8.9999C7.2005 8.6719 7.46882 8.3999 7.79237 8.3999H16.631C18.3592 8.3999 18.9116 9.1279 19.0932 9.5599C19.2668 9.9919 19.3851 10.9039 18.1541 12.1519L17.2071 13.1119C17.0098 13.3119 16.8993 13.5919 16.9072 13.8719C16.9151 14.1119 17.0098 14.3279 17.1755 14.4799L18.1541 15.4639C19.3615 16.6879 19.2431 17.5999 19.0695 18.0399C18.888 18.4639 18.3277 19.1999 16.631 19.1999Z"
      fill={props.color}
    />
  </svg>
);
export default SVGComponent;
